module.exports = {"640104001":"凤凰北街街道","640104002":"解放西街街道","640104003":"文化街街道","640104004":"富宁街街道","640104005":"新华街街道","640104006":"玉皇阁北街街道","640104007":"前进街街道","640104008":"中山南街街道","640104009":"银古路街道","640104010":"胜利街街道","640104011":"丽景街街道","640104100":"掌政镇","640104101":"大新镇","640104200":"通贵乡","640104201":"月牙湖乡","640104400":"燕鸽湖管委会"}


//////////////////
// WEBPACK FOOTER
// ./src/town/640104.json
// module id = 2812
// module chunks = 0